// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog } from '../../../base/dialog';

type Props = {
    alertText: ?string,
    disableOverlay: ?boolean,
    submitDisabled: ?boolean,
    cancelDisabled: ?boolean,
    titleKey: ?string,
    onSubmit: ?Function,
    okKey: ?string

}

const styleProps = {
    alertStyle: {
        position: 'relative',
        textAlign: 'center',
        padding: '5% 1% 5% 1%'
    }
};

/**
 * Alert Dialog.
 *
 * @param {Object} props - Props.
 *
 * @returns {any}
 */
export function AlertBox(props: Props) {
    const { t } = useTranslation();
    const { alertText = '', disableOverlay = false, submitDisabled = true, cancelDisabled = true, titleKey = '', onSubmit, okKey = 'ok' } = props;

    return (
        <Dialog
            cancelDisabled = { cancelDisabled }
            disableOverlay = { disableOverlay }
            okKey = { okKey }
            onSubmit = { onSubmit }
            submitDisabled = { submitDisabled }
            titleKey = { titleKey }
            width = 'small'>
            <div
                style = { styleProps.alertStyle }>
                <h4>{ alertText ? t(alertText) : 'Meeting has Ended'}</h4>
            </div>
        </Dialog>
    );
}


